import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import SPAInput from '../../shared/SPAInput';
import { Field } from '../../shared/formPanel';
import type { ProgramFormValues } from './programForm';

interface StoreOrderUrlsFieldsProps {
  form: UseFormReturn<ProgramFormValues>;
}

// The Store Order URLs fields, shared by the edit section and the New Program page.
const StoreOrderUrlsFields = ({ form: { register } }: StoreOrderUrlsFieldsProps) => (
  <div className="tw-flex tw-flex-col tw-gap-4">
    <Field htmlFor="program_order_url" label="Order URL">
      <SPAInput id="program_order_url" placeholder="https://" type="url" {...register('order_url')} />
    </Field>
    <Field htmlFor="program_materials_kit_order_url" label="Materials Kit Order URL">
      <SPAInput
        id="program_materials_kit_order_url"
        placeholder="https://"
        type="url"
        {...register('materials_kit_order_url')}
      />
    </Field>
    <Field htmlFor="program_refill_kit_order_url" label="Refill Kit Order URL">
      <SPAInput
        id="program_refill_kit_order_url"
        placeholder="https://"
        type="url"
        {...register('refill_kit_order_url')}
      />
    </Field>
  </div>
);

export default StoreOrderUrlsFields;
